import enUS from '@/locales/en-US.json'
import i18n, { Callback } from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
  lng: 'en-US',
  fallbackLng: 'en-US',
  debug: process.env.NODE_ENV === 'development',
  resources: { 'en-US': { translation: enUS } },
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
  returnNull: false,
})

const changeLanguage = i18n.changeLanguage
i18n.changeLanguage = async (locale: string, callback?: Callback) => {
  const loadLocale = async (locale: string) => {
    try {
      const translation = await import(`@/locales/${locale}.json`)
      const resources = { ...(translation || {}), ...(translation.default || {}) }
      i18n.addResourceBundle(locale, 'translation', resources, true, true)
    } catch (error) {
      console.log(error)
    }
  }

  await loadLocale(locale)

  return changeLanguage(locale, callback)
}

export const supportedLocales = [
  'ar-AR',
  'bg-BG',
  'bn-BD',
  'cs-CZ',
  'da-DK',
  'de-DE',
  'en-US',
  'es-ES',
  'fi-FI',
  'fr-FR',
  'hi-IN',
  'hu-HU',
  'id-ID',
  'it-IT',
  'ja-JP',
  'ko-KR',
  'la',
  'ms-MY',
  'my-MM',
  'nb-NO',
  'nl-NL',
  'pl-PL',
  'pt-BR',
  'pt-PT',
  'ro-RO',
  'ru-RU',
  'sr-Latn-RS',
  'sv-SE',
  'ta-IN',
  'th-TH',
  'tr-TR',
  'uk-UA',
  'vi-VN',
  'zh-CN',
  'zh-TW',
]
export default i18n
